import { useEffect, useMemo } from "react";
import gsap from "gsap";
import * as THREE from "three";
import { useSceneStore } from "@/state/useSceneStore";

const TEXTURE_URL = "/textures/book-inner.jpg";

export const Book = (): null => {
  const mesh = useSceneStore((s) => s.objects.book);
  const activeSection = useSceneStore((s) => s.activeSection);

  const innerTexture = useMemo(() => {
    const loader = new THREE.TextureLoader();
    const tex = loader.load(TEXTURE_URL);
    tex.flipY = false;
    tex.colorSpace = THREE.SRGBColorSpace;
    return tex;
  }, []);

  useEffect(() => {
    if (!mesh) return;
    const target = mesh as THREE.Mesh;
    const prevMaterial = target.material;
    target.material = new THREE.MeshStandardMaterial({
      color: 0xffffff,
      map: innerTexture,
    });
    return () => {
      (target.material as THREE.Material).dispose();
      target.material = prevMaterial;
      innerTexture.dispose();
    };
  }, [mesh, innerTexture]);

  useEffect(() => {
    if (!mesh) return;
    const cover = mesh.children[0];
    if (!cover) return;
    const target = activeSection === "about" ? Math.PI : 0;
    const tween = gsap.to(cover.rotation, {
      x: target,
      duration: 1.2,
    });
    return () => {
      tween.kill();
    };
  }, [mesh, activeSection]);

  return null;
};
